/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "hlopxqcblijivxrnayin"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhsb3B4cWNibGlqaXZ4cm5heWluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzODM2NjQsImV4cCI6MjA2ODk1OTY2NH0.2Buk_E2a0QyAONeOlnG04FJOC6J8GQxbKIrDDumOo28"